// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"865":"864ef17f","879":"f0e01f1c"}[chunkId] + ".chunk.js";
};